import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { shallow } from '@jwp/ott-common/src/utils/compare';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import useBreakpoint from '@jwp/ott-ui-react/src/hooks/useBreakpoint';

import SeeMoreItems from '../../components/SeeMoreItems/SeeMoreItems';

import styles from './SeeMoreItemsPage.module.scss';

const SeeMoreItemsPage = (): JSX.Element => {
  const { accessModel, favoritesList } = useConfigStore(
    (s) => ({
      accessModel: s.accessModel,
      favoritesList: s.config.features?.favoritesList,
    }),
    shallow,
  );
  const location = useLocation();
  // const { playlist } = location.state;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.state?.playlist) {
      sessionStorage.setItem('seeMorePlayList', JSON.stringify(location.state.playlist));
    }
  }, [location.state?.playlist]);

  const playlist = location.state?.playlist ?? JSON.parse(sessionStorage.getItem('seeMorePlayList') || 'null');
  const breakpoint = useBreakpoint();
  const { t } = useTranslation('user');

  const { user: customer, subscription, loading } = useAccountStore();

  return (
    <div className={styles.favouriteContainer}>
      <SeeMoreItems customer={!!customer} playlist={playlist} accessModel={accessModel} hasSubscription={!!subscription} />
    </div>
  );
};

export default SeeMoreItemsPage;
